export default ({ image, description, title }) => [
    {
        name: 'description',
        content: description,
    },
    {
        itemprop: 'description',
        content: description,
    },
    {
        itemprop: 'name',
        content: title,
    },
    ...(image
        ? [
              {
                  itemprop: 'image',
                  content: image.startsWith('/') ? `https://www.drivescore.com${image}` : image,
              },
          ]
        : []),
];
